import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../../_gori/helpers'

type Props = {
  titleId?: string
  subTextId?: string
  children?: React.ReactNode
}

export const EmptyRate = ({
  titleId = 'EMPTY_RATE',
  subTextId = 'EMPTY_RATE_SUB_TEXT',
  children = null,
}: Props) => {
  const intl = useIntl()
  return (
    <div className='d-flex flex-column align-items-center justify-content-center py-20'>
      <img
        src={toAbsoluteUrl('/media/gori/orders/empty-rate.svg')}
        alt='empty-rate'
        width={86}
        height={76}
      />
      <div className='mt-8 fw-bold text-gray-600 fs-6'>{intl.formatMessage({id: titleId})}</div>
      <div className='mt-2 text-gray-600 fw-medium text-center'>
        {intl.formatMessage({id: subTextId})}
      </div>
      {children ? <div className='mt-8'>{children}</div> : null}
    </div>
  )
}
